import { render, staticRenderFns } from "./articleItem.vue?vue&type=template&id=61f98d1c&scoped=true"
import script from "./articleItem.vue?vue&type=script&lang=js"
export * from "./articleItem.vue?vue&type=script&lang=js"
import style0 from "./articleItem.vue?vue&type=style&index=0&id=61f98d1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f98d1c",
  null
  
)

export default component.exports